import { Environment } from './environment.interface';

export const environment: Environment = {
  production: false,
  brands: {
    calibrant: {
      baseUrl: '/',
    },
  },
  defaults: {
    brand: 'calibrant',
    locale: 'en-us',
  },
  apiKey: '',
};
